import React from 'react';

function Header() {
  return (
    <nav role="navigation" class="light-blue lighten-1">
      <div class="nav-wrapper container">
        <ul id="nav-mobile" class="right hide-on-med-and-down">
          <li><a href="https://gitlab.com/uplift-code-camp/students/batch-16/elaijah-angelo-sapla/projects/-/tree/p3-react-app?ref_type=heads">Source Code</a></li>
        </ul>


        <div class="hide-on-small-only">
          <a href="/" class="brand-logo">Weather App</a>
        </div>

        <div class="hide-on-large-only center">
          <img src='https://ssl.gstatic.com/onebox/weather/64/partly_cloudy.png' alt="logo" />
        </div>

        <div class="hide-on-med-and-down">
          <img src='https://ssl.gstatic.com/onebox/weather/64/partly_cloudy.png' alt="logo" />
        </div>

      </div>
    </nav>
    
  );
}

export default Header;
